<template>
  <div class="goods">
    <v-head :title="title"></v-head>
    <div class="contentOffLine">
      <van-field
        v-model.trim="ruleForm.accountName"
        clearable
        required
        input-align="right"
        label="汇款人姓名"
        placeholder="请输入汇款人姓名"
      ></van-field>
      <van-field
        v-model.trim="ruleForm.accountNumber"
        clearable
        required
        input-align="right"
        label="汇款账号"
        placeholder="请输入汇款账号后四位"
      ></van-field>
      <van-field
        readonly
        v-model.trim="ruleForm.accountDate"
        clearable
        required
        input-align="right"
        label="汇款日期"
        @click="selectTime"
        placeholder="请选择汇款日期"
      ></van-field>

      <div style="padding: 20px 0; font-size:16px">
        <p style="margin-bottom:25px">注：<span> ( 只能上传jpg/png文件，且不超过500kb )</span></p>
        <div>
          <van-uploader
            v-model="fileList"
            multiple
            :max-count="1"
            :after-read="afterRead"
          />
        </div>
        <div style="margin-top: 20px">
          <van-button type="primary" block @click="submitForm">提交</van-button>
        </div>
      </div>
      <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
        <van-datetime-picker
          title="选择年月日"
          type="date"
          @cancel="show = false"
          @confirm="onConfirmTime"
        />
      </van-popup>
    </div>
  </div>
</template>

<script type="text/javascript">
import vHead from "../../components/Subhead.vue";

import { mapState } from "vuex";
import {
  Uploader,
  Toast,
  Field,
  Button,
  DatetimePicker,
  Popup,
  Cell,
  CellGroup,
} from "vant";
import { underLineSubmit, underLineSubmita } from "@/api/dictionary";
export default {
  data() {
    return {
      show: false,
      minDate: new Date(),
      fileList: [],
      commentImg: [],
      title: "线下支付",
      ruleForm: {
        accountName: "",
        accountNumber: "",
        accountDate: "",
      },
    };
  },
  components: {
    vHead,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Field.name]: Field,
    [Button.name]: Button,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
  },
  methods: {
    afterRead(item) {
      //this.ruleForm.file= item.file;
      this.portraitName = item.file.name;
      let params = new FormData();
      params.append("file", item.file);
      params.append("orderId", this.orderId);

      underLineSubmita(params).then((res) => {
        if (res.success) {
          Toast("上传成功");
        } else {
          Toast("上传失败");
        }
      });
    },
    submitForm() {
      console.log(this.ruleForm);
      if (!this.ruleForm.accountName) {
        Toast.fail("汇款账人姓名不能为空");
        return;
      }
      if (!this.ruleForm.accountNumber) {
        Toast.fail("汇款账号后四位不能为空");
        return;
      }
      if (!this.ruleForm.accountDate) {
        Toast.fail("汇款日期不能为空");
        return;
      }
      this.ruleForm.accountDate = this.ruleForm.accountDate.substr(0, 10);
      this.ruleForm.memberId = this.userInfo.id;
      this.ruleForm.orderId = this.orderId;
      this.ruleForm.memberCategory = this.userInfo.memberCategory;
      underLineSubmit(this.ruleForm).then((res) => {
        if (res.success) {
          this.titleFileId = res.result.id;
          Toast("上传成功");
          this.$router.push({ name: "PaymentList" });
        } else {
          Toast("上传失败");
        }
      });
    },
    onConfirmTime(value) {
      let date = value;
      let m = date.getMonth() + 1;
      let d = date.getDate();
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 0 && d <= 9) {
        d = "0" + d;
      }
      let timer = date.getFullYear() + "-" + m + "-" + d;
      this.ruleForm.accountDate = timer;
      this.show = false;
    },
    selectTime() {
      this.show = true;
    },
    obj() {
      var obj = {
        orderId: this.$route.params.id,
      };

      if (this.userInfo && this.from == "member") {
        obj.memberId = this.userInfo.id;
        obj.memberCategory = this.userInfo.memberCategory;
      }

      return obj;
    },
  },
  computed: {
    orderId() {
      return this.$route.query && this.$route.query.orderId;
    },
    ...mapState(["userInfo"]),
  },
};
</script>

<style lang="less" scoped>
.contentOffLine {
  padding: 20px 18px;
  .van-cell {
    padding: 15px 0;
  }
  .van-cell--required::before {
    display: none;
  }
  /deep/.van-cell--required .van-field__label::after {
    position: absolute;
    color: #ee0a24;
    font-size: 0.37333rem;
    content: "\00A0*";
  }
}
</style>